"use client";
import React from "react";
import Link from "next/link";
import CheckLink from "../../../utils/constants/LinkCheck";

export interface HeaderLink {
    linkText?: string;
    link?: string;
    linkType?: "internal" | "external";
    openInNewTab?: boolean;
}

export const FAQ_HEADER_LINK: HeaderLink = {
    linkText: "FAQs",
    link: "/faqs"
};

export interface HeaderContent {
    link1?: HeaderLink;
    link2?: HeaderLink;
    linkFinance?: {
        financeLink?: HeaderLink;
    };
    link3?: HeaderLink;
    link4?: {
        link4?: HeaderLink;
        link4SubMenu?: {
            subLink1?: HeaderLink;
            subLink2?: HeaderLink;
            subLink3?: HeaderLink;
        };
    };
    link5?: { linkText?: string; link?: string; image?: unknown };
}

export interface HamburgerCopyRight {
    hamburgerCopyRightsYear?: string;
    hamburgerCopyRightsText1?: string;
    hamburgerCopyRightsText2?: string;
}

interface SanityHeaderLinkProps {
    link?: HeaderLink | undefined;
    className: string;
    children: React.ReactNode;
    onClick?: ((event: React.MouseEvent<HTMLAnchorElement>) => void) | undefined;
    ariaLabel?: string | undefined;
}

const isExternalHref = (href: string) => /^(https?:\/\/|mailto:|tel:)/i.test(href);

export const SanityHeaderLink = ({ link, className, children, onClick, ariaLabel }: SanityHeaderLinkProps) => {
    const href = CheckLink(link?.link) || "#";
    const isExternal = link?.linkType === "external" || isExternalHref(href);
    const shouldOpenInNewTab = isExternal && link?.openInNewTab !== false;
    const commonProps = {
        className,
        ...(onClick ? { onClick } : {}),
        ...(ariaLabel ? { "aria-label": ariaLabel } : {})
    };

    if (isExternal) {
        return (
            <a
                href={href}
                {...(shouldOpenInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                {...commonProps}>
                {children}
            </a>
        );
    }

    return (
        <Link
            href={href}
            {...commonProps}>
            {children}
        </Link>
    );
};
